import styled, { keyframes, createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  .ant-tooltip {
    z-index: 20000 !important;
  }
`;

export const ContainerDiv = styled.div`
    z-index: 9000;
    position: absolute;
    top: 0;
    width: 100vw;
    min-height: 100vh;
    background-image: url(${props => props.img});
    background-color: white;
    padding-top: 60px;
`

export const Container = styled.li`
    display: flex;
    align-items: center;
    flex-direction: column;
    flex: 1;
    position: relative;
    height: auto;
    overflow-y: scroll;
`

export const GashaImg = styled.div`
    position: relative;
    display: inline-block;
    width: 90vw;
    height: 200px;
    border-radius: 20px;
    background-color: ${props => props.color};
    overflow: hidden;
    margin-top: 3%;
    margin-bottom: 2%;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
        display: block;
        width: 100%;
        height: auto;
    }

    h1 {
        position: absolute;
        top: 40%; /* Centrado verticalmente */
        left: 20vw; /* Centrado horizontalmente */
        transform: translate(-50%, -50%); /* Ajusta el centrado */
        color: white; /* Asegúrate de que el texto sea visible */
        z-index: 2; /* Ponlo por encima del pseudo-elemento */
        font-size: 1.5rem; /* Ajusta el tamaño según necesites */
        text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5); /* Mejora la legibilidad */
    }

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%; /* Ajusta el ancho del degradado */
        background: linear-gradient(to right,  ${props => props.color}, rgba(0, 0, 0, 0));
        pointer-events: none; /* Permite interacción con la imagen debajo */
    }
`

export const ModalBackground = styled.div`
    position: fixed;
    top: 0;
    z-index: 1010;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: start;
    align-items: center;
    padding-top: 20%;
    flex-direction: column;
`

export const ModalImgDiv = styled.div`
    position: relative;
    top: 0;
    width: 110%;
    height: 40%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    transform: translateY(-10px);
`
export const ModalImg = styled.img`
    position: relative;
    width: 101%;
`
export const ModalTitle = styled.h1`
    position: absolute;
    bottom: 0%; /* Centrado verticalmente */
    left: 10%; /* Centrado horizontalmente */
    color: white; /* Asegúrate de que el texto sea visible */
    font-size: 1.7rem; /* Ajusta el tamaño según necesites */
    text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.9); /* Mejora la legibilidad */
`

export const ModalContainer = styled.div`
    position: relative;
    width: 90vw;
    height: 550px;
    background-color: white;
    border-radius: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    border: 5px solid white;
`

export const ModalContainerCoins = styled.div`
    position: relative;
    width: 90vw;
    height: 50px;
    background-color: white;
    border-radius: 30px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    overflow: hidden;
    border: 5px solid white;
    margin-top: 20px;
`

export const CoinsDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`


const vibrate = keyframes`
  0% { transform: rotate(0deg); }
  25% { transform: rotate(-1deg); }
  50% { transform: rotate(1deg); }
  75% { transform: rotate(-1deg); }
  100% { transform: rotate(1deg); }
`;
export const ModalPull = styled.div`
    position: relative;
    margin-top: 5%;
    width: 95%;
    height: 100px;
    border: 1px solid black;
    border-radius: 10px;
    display: flex;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
    scroll-behavior: smooth; /* Agrega suavidad al desplazamiento */

    &.vibrating {
    animation: ${vibrate} 0.2s ease-in-out;
    }
`

export const HorizontalList = styled.div`
    display: flex;
    flex-wrap: nowrap; /* Evita que los elementos se rompan a la siguiente línea */
    overflow-x: auto; /* Agrega scroll horizontal si los elementos exceden el ancho */
    margin-left: 2px;
    margin-right: 2px;
    margin-top: 5px;
    /* Oculta la barra de desplazamiento si no quieres que se vea (opcional) */
    &::-webkit-scrollbar {
        display: none;
    }

    /* Estilos para los elementos dentro de la lista */
    img {
        flex: 0 0 auto; /* Evita que se redimensionen automáticamente */
        margin-left: 15px;
        min-height: 80%;
    }
`;

export const ModalPullTitle = styled.p`
    position: absolute;
    transform: translate(50%, -120%);
    background-color: white;
    font-weight: bold;
`

export const PoolImgWithStar = styled.div`
    height: 100px;
    margin: -15px -20px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`

export const ModalButtonContainer = styled.div`
    width: 95%;
    height: 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export const ModalButton = styled.div`
    width: 100%;
    height: 100%;
    margin: 30px 6px 0px 6px;
    display: inline-block;
    padding: 12px 24px;
    border-radius: 8px;
    color: black;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid black;
    position: relative;
    flex-direction: column;
    user-select: none;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-drag: none;
    -webkit-tap-highlight-color: transparent; /* Quita el resaltado azul en móviles */

    &::-webkit-scrollbar {
        display: none;
    }

    &:active {
        background: ${props => props.color};
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
        transform: translateY(2px);
    }
`

export const ModalBall = styled.img`
    width: 90%;
    user-select: none;
    pointer-events: none;
`

export const ModalConfirmContainer = styled.div`
    position: absolute;
    top: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 1020;
    display: flex;
    justify-content: center;
    align-items: start;
    padding-top: 30%;
`

export const ModalConfirm = styled.div`
    position: relative;
    width: 90vw;
    height: 300px;
    background-color: white;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`

export const ZonaContainer = styled.div`
    border: ${props => `3px solid ${props.color}`} ;
    border-radius: 25px;
    padding: 10px;
    background-color: ${props => `${props.color}60`};
    margin-bottom: 30px;
`

export const ZonaTitle = styled.h1`
    font-size: 1.8rem; /* Ajusta el tamaño según necesites */
    text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.8); /* Mejora la legibilidad */
    margin-left: 10px;
    color: white;
`